import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableClientNew = Loadable({
  loader: function loader() {
    return import('../Clients/ClientNew.jsx');
  },
  loading: ComponentLoading
});
export default LoadableClientNew;